import { render } from "./TrainingsmethodeIconComponent.vue?vue&type=template&id=63ea6e4a"
import script from "./TrainingsmethodeIconComponent.vue?vue&type=script&lang=js"
export * from "./TrainingsmethodeIconComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__